import _ from "lodash";
import React from "react";
import classes from "./BreadCrumbs.scss";

import { connect } from "react-redux";
import { goToIndex } from "modules/NavigationModule";

const goBackToIndex = ({ index, length, goToIndex }) => {
  goToIndex(-(length - index));
};
const BreadCrumbs = React.memo(props => {
  const { hierarchy = [], onHierarchyClick, goToIndex, currentRoute } = props;
  return (
    <div className={classes.breadCumContainer}>
      <div className={classes.firstRow}>
        {_.map(hierarchy, (item, index) => {
          return (
            <div className={classes.breadCumItem} key={item.id}>
              <span
                className={classes.breadCumText}
                onClick={() => {
                  if (onHierarchyClick) {
                    onHierarchyClick({ id: item.id });
                  } else {
                    goBackToIndex({
                      index,
                      length: hierarchy.length,
                      goToIndex,
                    });
                  }
                }}
              >
                {item.label}
              </span>
              {index < hierarchy.length - 1 ? "/ " : ""}
            </div>
          );
        })}
      </div>
      {currentRoute && <div className={classes.secondRow}>{currentRoute}</div>}
    </div>
  );
});

BreadCrumbs.displayName = "BreadCrumbs";

const mapActionCreators = {
  goToIndex,
};

const mapStateToProps = (state, ownProps) => {
  return {};
};

export default connect(mapStateToProps, mapActionCreators)(BreadCrumbs);
